<a
  class="gallery-list-item"
  [routerLink]="link() ?? ['/a', 'gallery', gallery().id | removeIdPrefix, 'designer']"
  appInferredHover="gallery-{{ gallery().id }}"
>
  @if (gallery().teaser?.uuid) {
    <img
      [src]="gallery() | galleryTeaserUrl: 60"
      [style.object-position]="gallery().teaser.uuid === gallery().cover.uuid ? gallery().cover.position : undefined"
      class="gallery-asset"
      loading="lazy"
      alt=""
    />
  }
  @if (!gallery().teaser?.uuid) {
    <div class="gallery-asset"></div>
  }
  <div class="gallery-info">
    <b class="gallery-title">{{ gallery().name || gallery().title || 'Untitled' }}</b>
    <div class="meta">
      @if (!publicMode() && gallery().show_in_profile) {
        <span class="public-dot" appTooltip="Visible on your public profile"></span>
      }
      @if (gallery().parent_gallery_id) {
        <span>Sub-Gallery ⋅ </span>
      }
      <span
        >{{ gallery().total_assets_count }}
        @if (gallery().total_assets_count === 1) {
          Asset
        } @else {
          Assets
        }
      </span>
      @if (!gallery().parent_gallery_id) {
        <span> ⋅ {{ gallery().last_changed_at * 1000 | relativeTime }}</span>
      }
    </div>
  </div>
  @if (!publicMode()) {
    <button
      appButton
      name="favorite"
      location="gallery-list-item"
      [color]="gallery().is_favourite ? 'simple-yellow' : 'simple-gray'"
      [iconButton]="true"
      height="1"
      (click)="toggleFavorite($event)"
      shape="round"
      class="favorite-button"
      [class.empty]="!gallery().is_favourite"
    >
      @if (!gallery().is_favourite) {
        <app-svg src="/assets/icons/star-empty.svg"></app-svg>
      } @else {
        <app-svg src="/assets/icons/star-filled.svg"></app-svg>
      }
    </button>
    <app-context-menu
      [options]="{ width: '240px', noSpacing: true }"
      #menu
      class="more-button-container"
      name="gallery-list-item-options"
      contextHoverIdentifier="gallery-{{ gallery().id }}"
    >
      <button
        appButton
        name="options"
        location="gallery-list-item"
        [analyticsExtra]="{ galleryId: gallery()?.id }"
        [iconButton]="true"
        shape="round"
        height="1"
        color="simple-gray"
        class="more-button"
        contextButton
      >
        <app-svg src="/assets/icons/dots-vertical.svg"></app-svg>
      </button>
      <div contextContent>
        @if (menu.isOpen()) {
          <app-gallery-context-menu [gallery]="gallery()" (onClose)="menu.close()"> </app-gallery-context-menu>
        }
      </div>
    </app-context-menu>
  }
</a>
